var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDMinus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 23,
    viewBox: "0 0 15 23",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.945312 21.5596L13.4453 20.0596",
    stroke: "currentColor",
    strokeWidth: 1.7,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0254 0.0800781V1.03613H9.86523V0.0800781H14.0254Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.16
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.80865 17.5596H0.875V2.55957H5.90817C7.35367 2.55957 8.59538 2.85986 9.63329 3.46045C10.6759 4.05615 11.4769 4.91309 12.0361 6.03125C12.5954 7.14941 12.875 8.48731 12.875 10.0449C12.875 11.6074 12.593 12.9502 12.029 14.0732C11.4698 15.1963 10.6617 16.0581 9.60486 16.6587C8.55272 17.2593 7.28732 17.5596 5.80865 17.5596ZM3.51244 15.2085H5.68069C6.69491 15.2085 7.54088 15.0181 8.2186 14.6372C8.89633 14.2515 9.40581 13.6777 9.74704 12.916C10.0883 12.1494 10.2589 11.1924 10.2589 10.0449C10.2589 8.89746 10.0883 7.94531 9.74704 7.18848C9.40581 6.42676 8.90107 5.85791 8.23282 5.48193C7.56931 5.10107 6.74467 4.91065 5.75889 4.91065H3.51244V15.2085Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDMinus);
export default __webpack_public_path__ + "static/media/d-minus.bdfce4b8dd122a00f4d06d1763262e9d.svg";
export { ForwardRef as ReactComponent };